import { useMutation } from '@apollo/client';
import { useCountry } from '../../components/CountrySelector';
import { useUser } from '../useUser';
import { useCart, GET_CART_QUERY } from '../useCart';
import { ADDRESSES_QUERY } from '../useAddress/useAddressesQuery';
import { PAYMENT_METHODS_QUERY } from '../usePaymentMethods/usePaymentMethodsQuery/paymentMethodsQuery.rest';
import {
  CREATE_PAYPAL_PAYMENT_METHOD_MUTATION,
  CreatePayPalPaymentMethodMutation,
  CreatePayPalPaymentMethodMutationVariables
} from './createPayPalPaymentMethodMutation.rest';

export const useCreatePayPalPaymentMethodMutation = () => {
  const { cart } = useCart();
  const { country } = useCountry();
  const {
    user: { accessToken }
  } = useUser();

  const getCartQuery = {
    query: GET_CART_QUERY,
    variables: {
      cartId: cart.id,
      cartVersion: cart.attributes.version,
      countryCode: country.alpha2Code
    }
  };

  return useMutation<CreatePayPalPaymentMethodMutation, CreatePayPalPaymentMethodMutationVariables>(
    CREATE_PAYPAL_PAYMENT_METHOD_MUTATION,
    {
      refetchQueries: accessToken
        ? [
            getCartQuery,
            {
              query: ADDRESSES_QUERY
            },
            {
              query: PAYMENT_METHODS_QUERY
            }
          ]
        : [getCartQuery],
      awaitRefetchQueries: true
    }
  );
};
